import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=289d694c&scoped=true&"
import script from "./Back.vue?vue&type=script&lang=js&"
export * from "./Back.vue?vue&type=script&lang=js&"
import style0 from "./Back.vue?vue&type=style&index=0&id=289d694c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d694c",
  null
  
)

export default component.exports